var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconConsoleLogWarning = function SvgIconConsoleLogWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16258_21403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.12V9.38",
    stroke: "#FF9F0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 16.375C12.25 16.5131 12.1381 16.625 12 16.625C11.8619 16.625 11.75 16.5131 11.75 16.375C11.75 16.2369 11.8619 16.125 12 16.125",
    stroke: "#FF9F0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.125C12.1381 16.125 12.25 16.2369 12.25 16.375",
    stroke: "#FF9F0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0288 4.139L21.6878 17.543C22.5778 19.101 21.4528 21.04 19.6588 21.04H4.34076C2.54576 21.04 1.42076 19.101 2.31176 17.543L9.97076 4.139C10.8678 2.568 13.1318 2.568 14.0288 4.139Z",
    stroke: "#FF9F0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16258_21403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgIconConsoleLogWarning as ReactComponent };
export default __webpack_public_path__ + "icon-console-log-warning.svg";